import { useRef, useState } from "react";
import { toast } from "sonner";
import { UploadCloud, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { resizeImage } from "@/lib/resizeImage";

const ACCEPT = ["image/jpeg", "image/png", "image/webp"];

export const UploadZone = ({ onUploaded }) => {
    const inputRef = useRef(null);
    const [drag, setDrag] = useState(false);
    const [progress, setProgress] = useState(null);

    const uploadFiles = async (fileList) => {
        const files = [...fileList].filter((f) => ACCEPT.includes(f.type));
        if (!files.length) {
            toast.error("Formato non supportato: usa JPG, PNG o WebP.");
            return;
        }
        let done = 0;
        setProgress({ done, total: files.length });
        for (const original of files) {
            try {
                const file = await resizeImage(original);
                const fd = new FormData();
                fd.append("file", file);
                fd.append("title", original.name.replace(/\.[^.]+$/, "").replace(/[-_]+/g, " "));
                const { data } = await api.post("/admin/gallery", fd);
                onUploaded(data);
            } catch (err) {
                toast.error(`${original.name}: ${apiError(err, "caricamento non riuscito")}`);
            }
            done += 1;
            setProgress({ done, total: files.length });
        }
        setProgress(null);
        toast.success(done === 1 ? "Foto caricata." : `${done} foto elaborate.`);
    };

    return (
        <div
            data-testid="admin-upload-zone"
            onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
            onDragLeave={() => setDrag(false)}
            onDrop={(e) => { e.preventDefault(); setDrag(false); uploadFiles(e.dataTransfer.files); }}
            className={`relative border border-dashed p-10 text-center transition-colors duration-300 ${
                drag ? "border-tl-orange bg-tl-orange/5" : "border-white/20 bg-white/[0.02]"
            }`}
        >
            <input
                ref={inputRef}
                data-testid="admin-upload-input"
                type="file"
                accept={ACCEPT.join(",")}
                multiple
                className="hidden"
                onChange={(e) => { uploadFiles(e.target.files); e.target.value = ""; }}
            />
            {progress ? (
                <>
                    <Loader2 size={30} className="mx-auto animate-spin text-tl-orange" />
                    <p data-testid="admin-upload-progress" className="mt-4 font-mono-tl text-xs uppercase tracking-[0.25em] text-white">
                        Caricamento {progress.done}/{progress.total}
                    </p>
                </>
            ) : (
                <>
                    <UploadCloud size={30} strokeWidth={1.5} className="mx-auto text-tl-orange" />
                    <p className="mt-4 font-display text-lg font-semibold text-white">Trascina qui le foto</p>
                    <p className="mt-1 text-sm text-tl-mutedLight">JPG, PNG o WebP · ridimensionate automaticamente</p>
                    <button
                        type="button"
                        data-testid="admin-upload-button"
                        onClick={() => inputRef.current?.click()}
                        className="mt-6 bg-tl-orange px-6 py-3 font-mono-tl text-xs font-semibold uppercase tracking-[0.2em] text-tl-dark transition-colors hover:bg-tl-orangeHover"
                    >
                        Scegli le foto
                    </button>
                </>
            )}
        </div>
    );
};
